import { formatNumber } from './formatNumber';
import { isNumber } from './isNumber';

import { CURRENCY, FRACTION_LENGTH } from '../constants';

export function formatCurrency(input, options = {}) {
  if (isNumber(options)) options = { fractionLength: options };
  return formatNumber(input, { style: 'currency', currency: CURRENCY, fractionLength: FRACTION_LENGTH, ...options });
}
